<template>
  <b-row>
    <b-col cols="12" class="mb-5 mt-4">
      <PageTitle title="Acesso a usuários" />
    </b-col>
    <b-col>
      <b-alert variant="warning" show>
        <b>Atenção:</b> Esta funcionalidade permite que você acesse a conta de
        outro usuário, cuidado ao utilizá-la.
      </b-alert>
    </b-col>
    <b-col cols="12">
      <b-form-group label="Filtrar por e-mail">
        <b-form-input
          v-model="filters.email"
          placeholder="Digite o e-mail do usuário"
          @keydown.enter="resetPagination"
        ></b-form-input>
      </b-form-group>
    </b-col>
    <b-col cols="12" class="mb-2">
      <b-button
        variant="success"
        @click="resetPagination"
        :disabled="loading"
        class="mr-2"
      >
        <i class="fas fa-search mr-2"></i> Buscar
      </b-button>
    </b-col>
    <b-col cols="12">
      <b-table
        striped
        responsive
        hover
        show-empty
        bordered
        :fields="table.headers"
        :items="table.records"
        :busy="loading"
      >
        <template #cell(action)="{ item }">
          <b-button
            variant="outline-success"
            size="sm"
            :title="`Acessar a plataforma como '${item.email}'`"
            @click="$refs.accessUserModal.open(item)"
          >
            <i class="fas fa-external-link-alt mr-2"></i> Acessar
          </b-button>
          <ImpersonateActions
            @seeAccess="$refs.loginsModal.open(item)"
            @accessLink="$refs.accessLinkModal.open(item)"
          />
        </template>
      </b-table>
      <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.itemsPerPage"
        :disabled="loading"
        align="center"
        pills
        @change="(page) => {
          pagination.currentPage = page;
          getUsers();
        }"
      ></b-pagination>
    </b-col>

    <AccessUserModal ref="accessUserModal" />
    <LoginsModal ref="loginsModal" />
    <AccessLinkModal
      ref="accessLinkModal"
      @openNewAccess="$refs.accessUserModal.open($event)"
    />
  </b-row>
</template>

<script>
import PageTitle from 'Components/PageTitle.vue';
import makeToast from 'Mixins/makeToast';
import api from '@/api';
import { mapGetters } from 'vuex';
import { mapLabel } from '@/enums/UserTypes';
import AccessUserModal from './_components/AccessUserModal.vue';
import AccessLinkModal from './_components/AccessLinkModal.vue';
import LoginsModal from './_components/LoginsModal.vue';
import ImpersonateActions from './_components/Actions.vue';

export default {
  name: 'Impersonate',
  mixins: [makeToast],
  computed: {
    ...mapGetters(['getToken']),
  },
  data() {
    return {
      loading: false,
      filters: {
        email: '',
      },
      table: {
        records: [],
        headers: [
          {
            key: 'id',
            label: 'Id Constr Up',
          },
          {
            key: 'email',
            label: 'E-mail',
          },
          {
            key: 'userType',
            label: 'Tipo de usuário',
            formatter(value) {
              return mapLabel(value);
            },
          },
          {
            key: 'action',
            label: 'Ações',
            thClass: 'text-center',
            tdClass: 'text-center',
          },
        ],
      },
      pagination: {
        currentPage: 1,
        itemsPerPage: 20,
        total: 0,
        lastPage: 0,
      },
    };
  },
  mounted() {
    this.getUsers();
  },
  methods: {
    resetPagination() {
      this.pagination.currentPage = 1;
      this.pagination.total = 0;

      this.getUsers();
    },
    async getUsers() {
      this.loading = true;

      try {
        const queryParams = new URLSearchParams({
          email: this.filters.email,
          page: this.pagination.currentPage,
          perPage: this.pagination.itemsPerPage,
        });

        const response = await api.get(
          `/v1/admin/impersonate/users?${queryParams.toString()}`,
          {
            headers: {
              Authorization: `Bearer ${this.getToken}`,
            },
          }
        );
        const { total, data } = response.data;
        this.table.records = data || [];
        this.pagination.total = total;
      } catch (error) {
        this.makeToast(
          'Erro',
          `Houve um erro ao buscar os usuários: "${error.message}"`,
          'danger'
        );
      } finally {
        this.loading = false;
      }
    },
  },
  components: {
    PageTitle,
    AccessUserModal,
    ImpersonateActions,
    LoginsModal,
    AccessLinkModal,
  },
};
</script>
